/* eslint-disable import/no-anonymous-default-export */

const authState = {
    isLogin: false,
    isRegister: false,
    token: '',
    isLoading: false,
    isError: false,
    alertMsg: '',
    level: 0,
    isRoute: false,
    listUser: [],
    dataToken: {},
    disableRoute: [
        'depo', 'menu', 'tempmail', 'role', 'user',
        'dokumen', 'approval'
    ]
};

export default (state=authState, action) => {
        switch(action.type){
            case 'AUTH_USER_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Login in ....'
                };
            }
            case 'AUTH_USER_FULFILLED': {
                const { user, access_token, refresh_token } = action.payload.data

                localStorage.setItem('token', access_token)
                localStorage.setItem('refresh_token', refresh_token)
                localStorage.setItem('level', user.user_level)
                localStorage.setItem('name', user.username)
                localStorage.setItem('fullname', user.fullname)
                localStorage.setItem('email', user.email)
                localStorage.setItem('kode', user.kode_plant)
                localStorage.setItem('id', user.id)
                localStorage.setItem('role', user.role)
                localStorage.setItem('it', user.status_it)
                localStorage.setItem('dataUser', user.dataUser.length)
                return {
                    ...state,
                    level: user.user_level,
                    isLogin: true,
                    isError: false,
                    isLoading: false,
                    token: action.payload.data.Token,
                    listUser: user.dataUser,
                    alertMsg: 'Login Succesfully'
                };
            }
            case 'AUTH_USER_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    isLogin: false,
                    isError: true,
                    alertMsg: 'Login Failed'
                };
            }
            case 'CH_PLANT_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Login in ....'
                };
            }
            case 'CH_PLANT_FULFILLED': {
                localStorage.setItem('chplant', action.payload.data.result.kode_plant)
                return {
                    ...state,
                    isLoading: false,
                    alertMsg: 'Login Succesfully'
                };
            }
            case 'CH_PLANT_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    alertMsg: 'Login Failed'
                };
            }
            case 'GET_LOGIN_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Login in ....'
                };
            }
            case 'GET_LOGIN_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    listUser: action.payload.data.result,
                    alertMsg: 'Login Succesfully'
                };
            }
            case 'GET_LOGIN_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    alertMsg: 'Login Failed'
                };
            }
            case 'GET_TOKEN_PENDING': {
                return {
                    ...state,
                    isLoading: true,
                    alertMsg: 'Login in ....'
                };
            }
            case 'GET_TOKEN_FULFILLED': {
                return {
                    ...state,
                    isLoading: false,
                    dataToken: action.payload.data.result,
                    alertMsg: 'Login Succesfully'
                };
            }
            case 'GET_TOKEN_REJECTED': {
                return {
                    ...state,
                    isLoading: false,
                    alertMsg: 'Login Failed'
                };
            }
            case 'SET_TOKEN': {
                return {
                  ...state,
                  token: action.payload.token,
                  isLogin: true,
                }
            }
            case 'LOGOUT': {
                localStorage.removeItem('token')
                localStorage.removeItem('level')
                localStorage.removeItem('chplant')
                localStorage.removeItem('dataUser')
                return {
                    state: undefined
                }
            }

            case 'REFRESH_TOKEN_FULFILLED': {
                const { access_token, refresh_token } = action.payload.data

                localStorage.setItem('token', access_token)
                localStorage.setItem('refresh_token', refresh_token) // rotasi

                return { ...state, token: access_token, isLogin: true }
            }

            case 'REFRESH_TOKEN_REJECTED': {
                // refresh token expired → paksa logout
                localStorage.clear()
                return { ...authState, isLogin: false }
            }
            case 'RESET': {
                return {
                    ...state,
                    isLogin: false,
                    isRoute: false
                }
            }
            case 'ROUTE' : {
                return {
                    ...state,
                    isRoute: true
                }
            }
            default: {
                return state;
            }
        }
    }